const pageLoadingActionTypes = {
  SET_IS_PAGE_LOADING: 'SET_IS_PAGE_LOADING',
};

export default pageLoadingActionTypes;
